module.exports = __webpack_public_path__ + "static/media/acne.2909fb88.svg";